import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Link } from 'react-router-dom'

const Toasters = () => (
  <Query
    query={gql`
      {
        toasters {
          edges {
            node {
              title
              slug
            }
          }
        }
      }
    `}
  >
    {({ loading, error, data }) => {
      if (loading) {
        return <p>loading</p>
      }

      return (
        <div>
          {'hi'}
          {console.log(data.toasters)}
          {data.toasters.edges.map((toaster, key) => (
            <div key={key}>
              <Link
                style={{
                  color: 'red',
                  display: 'block',
                  textDecoration: 'underline',
                }}
                to={`/toaster/${toaster.node.slug}`}
              >
                {toaster.node.title}
              </Link>
            </div>
          ))}
        </div>
      )
    }}
  </Query>
)
export default Toasters
